// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.secondNav {\r\n  font-size:  19px;\r\n  color: var(--mainColor);\r\n  display: flex;\r\n  align-items: center;\n}\n.navbar {\r\n  justify-content:space-between;\r\n  padding: 3px 6px;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
